import { Button, RadioGroup, Spinner } from "@design";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { errorMessage } from "@/api";
import { Text } from "@/components/Text";
import { useDevAuth } from "./DevAuthProvider";
import { fetchDevPersonas } from "./devAuthApi";

/** Sign-in for dev auth: pick a test persona instead of logging in with an IdP. */
export function DevPersonaPicker() {
  const dev = useDevAuth();
  const { t } = useTranslation("devAuth");
  const personas = useQuery({ queryKey: ["dev-auth", "personas"], queryFn: fetchDevPersonas, staleTime: Infinity });
  const [selected, setSelected] = useState<string>();

  if (personas.isPending) return <Spinner aria-label={t("picker.loading")} />;
  if (personas.isError) {
    return (
      <Text tone="error" role="alert">
        {t("picker.loadFailed", { reason: errorMessage(personas.error, t("picker.loadFailedHint")) })}
      </Text>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 text-left">
      <Text variant="eyebrow" tone="tertiary" as="h2">
        {t("picker.heading")}
      </Text>
      <RadioGroup
        aria-label={t("picker.label")}
        value={selected}
        onChange={setSelected}
        options={personas.data.map((p) => ({ value: p.key, label: p.name, description: p.description }))}
      />
      <Button variant="primary" disabled={!selected} onClick={() => selected && dev?.signInAs(selected)}>
        {t("picker.continue")}
      </Button>
    </div>
  );
}
